import { fetchBlocklistCheck } from '@/utils/http/fetchBlocklistCheck';

export const matchTextAgainstBlocklist = async (text: string) => {
  const response = await fetchBlocklistCheck(text.replace(/\s+/g, ' '));

  if (!response) {
    return '';
  }

  const blocked: string[] = [];
  for (const { blockedTerms } of response.results) {
    blocked.push(...blockedTerms);
  }

  return blocked.join(', ');
};
